import { RouterManager } from '@aclass/admin/managers';
import { PipelineStory } from '@aclass/admin/storage/actions';
import { IAdminState, IPipelineModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class PipelineSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:pipeline-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IPipelineModuleState['searchPageInitialized']>(['pipelineModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(PipelineSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(PipelineStory.dryRunSearchPage());
    }
}
